<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Map Subscription">
      <div class="row">
       <div class="col-md-6 form-group">
           Select College
          <b-form-select v-model="college" @change="getSubsriptions()" required>
            <option
              v-for="(college, index) in colleges"
              :key="index"
              :value="college.id"
            >
              {{ college.name }}
            </option>
          </b-form-select>
          <div v-if="collegeEmpty" style="color: red">
            College is required
          </div>
        </div>

        <div class="col-md-6 form-group">
           Select Subscriptions
          <b-form-select 
              multiple="true" 
            
              v-model="subscription"
              required>
            <option
              v-for="(subscription, index) in subscriptions"
              :key="index"
              :value="subscription.id"
            >
              {{ subscription.name }}
            </option>
          </b-form-select>
          <div v-if="subscriptionEmpty" style="color: red">
            subscription is required
          </div>
        </div>

        <div class="col-md-6 form-group">
          Students Count
          <input v-model="studentcount" class="form-control"/>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          type="submit"
          @click="addCollegeSubscription()"
          >Save</b-button
        >
      </div>
    </base-block>
  </div>
</template> 

<script>
import axios from "axios";
export default {
  data() {
    return {
      colleges: [],
      college:"",
      subscriptions:[],
      subscription:[],
      studentcount: "",
      multiple: true,
      collegeEmpty: false,
      subscriptionEmpty: false,
      studentcountEmpty: false,
    };
  },
  mounted() {
    this.getColleges();
  },
  methods: {
    async addCollegeSubscription() {
      if (this.college == "") {
        this.collegeEmpty = true;
        return;
      }

      if (this.subscription == "") {
        this.subscriptionEmpty = true;
        return;
      }

      if (this.studentcount == "") {
        this.studentcountEmpty = true;
        return;
      }

      //let topicIds = [this.college, this.subscription];
      console.log(this.subscription);
      const formdata = new FormData();
      formdata.append("subscriptions[college_id]", this.college);
      formdata.append("subscriptions[studentcount]", this.studentcount);
      formdata.append("subscriptions[sub_ids]", this.subscription);
      //formdata.append("description", this.description);
      await axios
        .post(`${this.$store.getters.baseUrl}/college/sub-store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.getColleges();
            this.$swal("Success", "College Subscription added successfully", "success");
            this.$router.push({name: 'Colleges'});
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getColleges(){
      await axios
        .get(`${this.$store.getters.baseUrl}/get/colleges`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.colleges = response.data.colleges;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getSubsriptions() {
      this.collegeEmpty = false;
      this.subscription = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/college/sub-list/${this.college}`,{
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subscriptions = response.data.subscriptions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

